import { ContentState, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";

import { uploadImageWithDraftEditor } from "../../../Components/molecules";
import { ContentContext } from "../../../Provider";
import { endpoints, parseEndpoint } from "../../../Services/endpoints";
import { getObjUUID, sanitizeHtmlString } from "../../../utils/common";
import { customChunkRenderer, entityMapper } from "../../../utils/editorUtils";

const useProgramInfoViewQAMgtScreen = () => {
  const contentContext = useContext(ContentContext);
  const { user, apiRequest } = contentContext;
  const intl = useIntl();
  const companyId = getObjUUID(user.company);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [programInfoStatus, setProgramInfoStatus] = useState("private");
  useEffect(() => {
    getExistingProgramQAInfo();
  }, []);
  const getExistingProgramQAInfo = () => {
    const requestBuilder = {
      method: "getRequest",
      url: parseEndpoint(endpoints.programInfoQA),
      data: {},
    };
    // @ts-expect-error TS2345
    apiRequest(requestBuilder, ({ data }) => {
      // @ts-expect-error TS18046
      if (data.content) {
        const contentBlock = htmlToDraft(
          // @ts-expect-error TS18046
          sanitizeHtmlString(data.content),
          // @ts-expect-error TS2345
          customChunkRenderer,
        );

        if (contentBlock) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock.contentBlocks,
          );
          setEditorState(EditorState.createWithContent(contentState));
        }
      }
      // @ts-expect-error TS18046
      setProgramInfoStatus(data.status ? data.status : "private");
    });
  };
  const getMarkUpAsHtml = (): string => {
    const dirtyHtml = draftToHtml(
      convertToRaw(editorState.getCurrentContent()),
      {},
      false,
      entityMapper,
    );
    return sanitizeHtmlString(dirtyHtml);
  };
  // @ts-expect-error TS7006
  const saveQAInfo = (data) => {
    const requestBuilder = {
      method: "postRequest",
      url: parseEndpoint(endpoints.programInfoQA),
      data,
      successMessage: intl.formatMessage({
        id: "screen.label.qa_saved_program",
      }),
    };
    // @ts-expect-error TS2345
    apiRequest(requestBuilder, ({ data }) => {
      getExistingProgramQAInfo();
      // @ts-expect-error TS2322
      window.location = "/dashboard/program-info-view-qa";
    });
  };
  const uploadImageCallBack = (file: any) => {
    return new Promise((resolve, reject) => {
      uploadImageWithDraftEditor({
        file,
        companyId,
        authToken: user.token,
        subLink: "program_info_qa",
        headerDetail: {
          type: "program_info_qa",
        },
      })
        .then((response: any) => {
          resolve(response);
        })

        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    intl,
    authUser: user,
    companyId,
    editorState,
    setEditorState,
    programInfoStatus,
    setProgramInfoStatus,
    getExistingProgramQAInfo,
    getMarkUpAsHtml,
    saveQAInfo,
    uploadImageCallBack,
  };
};

export default useProgramInfoViewQAMgtScreen;
